/** ========================================================================= *\
 * @prefab HUD
 * ========================================================================== */
import * as CONST from 'config';

class HUD extends Phaser.Group {

  /** @constructor ---------------------------------------------------------- */
  constructor(game, healthCount) {
    super(game, null);

    // Create Health Indicator
    this.healthIndicator = new HealthIndicator(game, healthCount);
  }

}

class HealthIndicator extends Phaser.Group {
  /** Properties ------------------------------------------------------------ */
  healthSprites = [];

  /** @constructor ---------------------------------------------------------- */
  constructor(game, healthCount) {
    super(game);
    this.fixedToCamera = true;

    // Configuration
    const spacing = 6;
    const spriteWidth = this.game.cache.getImage('heart').width;

    // Create health sprite items
    for (let i = 0; i < healthCount; i++) {
      const xPos = (i * (spriteWidth + spacing)) + CONST.HUD_PADDING;
      const yPos = CONST.HUD_PADDING;
      const sprite = new Phaser.Sprite(game, xPos, yPos, 'heart', 1);
      sprite.anchor.set(0, 0);
      this.add(sprite);
      this.healthSprites.push(sprite);
    }

    // Reverse the array so the left most heart disappears first
    this.healthSprites.reverse();

    // Listen for damage events
    game.onDamage.add(this.onDamage, this);
    // Listen for add lives events
    game.onAddLives.add(this.onAddLives, this);
  }

  onDamage() {
    // Kill the first available health sprite
    if(this.game.damage === 1){
      const healthSpriteToKill = this.healthSprites.find(h => h.visible);
      healthSpriteToKill.visible = false;
    }
  }
  onAddLives(){
    console.log(this.healthCount)
    // const healthSpriteToKill = this.healthSprites.find(h => h.visible);
    // healthSpriteToKill.visible = true;
  }
}

export default HUD;

// export default class Hud extends Phaser.Group {
//     constructor({ game, doggy }) {
//         super(game);
//         this.game = game;
//         this.doggy = doggy;

//         // this.width = this.game.world.width
//         this.healthbar = new Phaser.Sprite(this.game, 2, 2, 'healthbar');
//         this.healthbar.scale.setTo(1, 11);
//         this.healthbar.width = this.game.width


//         this.text = new Phaser.Text(this.game, this.game.world.centerX, this.game.height-150, 'Press spacebar to Jump over the Obstacles to get Wang Chai home safe', {
//             font: '12px Verdana',
//             fill: '#ffeb9a',
//             align: 'center'
//         });
//         this.Logo = new Phaser.Sprite(this.game, this.game.world.centerX, this.game.height-100, 'logo');
//         this.Logo.anchor.setTo(0.5);
//         this.text.anchor.setTo(0.5);
//         this.add(this.healthbar);
//         this.add(this.text);
//         this.add(this.Logo);
//     }

//     updateHealth() {
//         this.healthbar.crop(new Phaser.Rectangle(0, 0, (this.doggy.health / this.doggy.maxHealth) * this.width, 10));
//         this.healthbar.updateCrop();
//     }
// };



// WEBPACK FOOTER //
// ./js/prefabs/hud.js